import React from 'react';
import { navigate } from 'gatsby';
import { Card, Header, Subhead, ButtonOutline, Box, Flex } from 'rebass';
import CheckoutSelect from './CheckoutSelect';
import Text from './Text';
import styled from 'styled-components';

const CheckoutButton = styled(ButtonOutline)`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`;

const lifeTimeAmount = 16000;
// hardcoded amount (in US cents) to charge users
// you could set this variable dynamically to charge different amounts

// Below is where the checkout component is defined.
// It has several functions and some default state variables.
const Checkout = class extends React.Component {
  state = {
    disabled: false,
    buttonText: '',
    paymentMessage: '',
    amount: 4900,
    plan: '',
  };

  resetButton() {
    this.setState({ disabled: false, buttonText: 'Join' });
  }

  updatePlan = option => {
    let buttonText;
    let planId;
    let amount;
    // set Plan + Button by option
    if (option == 1) {
      buttonText = 'Pay $15';
      planId = process.env.STRIPE_MONTHLY;
      amount = 1500;
    } else if (option == 2) {
      buttonText = 'Pay $84';
      planId = process.env.STRIPE_YEARLY;
      amount = 8400;
    } else if (option == 3) {
      buttonText = 'Pay $160';
      planId = '';
      amount = 16000;
    }

    this.setState({
      plan: option,
      buttonText,
      amount,
    });
  };

  componentDidUpdate() {
    // console.log(process.env.STRIPE_PUBLISHABLE_KEY);
    this.stripeHandler = window.StripeCheckout.configure({
      // You’ll need to add your own Stripe public key to the `checkout.js` file.
      // key: 'pk_test_STRIPE_PUBLISHABLE_KEY',
      key: process.env.STRIPE_PUBLISHABLE_KEY,
      zipCode: true,
      locale: 'auto',
      source: source => {
        fetch(process.env.STRIPE_ENDPOINT, {
          method: 'POST',
          mode: 'no-cors',
          body: JSON.stringify({
            source,
            option: this.state.plan,
            amount: this.state.amount,
            lifeTimeAmount,
          }),
          headers: new Headers({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Content-Type',
          }),
        })
          .then(res => {
            // console.log(res);
            // console.log('Transaction processed successfully');
            this.resetButton();
            navigate('/confirmation-success');

            return res;
          })
          .catch(error => {
            // console.error('Error:', error);
            this.setState({ paymentMessage: 'Payment Failed. Try again?' });
          });
      },
      closed: () => {
        this.resetButton();
      },
    });
  }

  openStripeCheckout(event) {
    const amount = this.state.amount;
    event.preventDefault();
    this.setState({ disabled: true, buttonText: 'Loading...' });
    this.stripeHandler.open({
      name: 'Launching Myself',
      amount,
      description: 'Build useful software, faster',
    });
  }

  renderButton() {
    if (this.state.plan) {
      return (
        <div>
          <CheckoutButton
            fontSize={2}
            lineHeight={2}
            width="100%"
            m="20px"
            color="base"
            onClick={event => this.openStripeCheckout(event)}
            disabled={this.state.disabled}
          >
            {this.state.buttonText}
          </CheckoutButton>
          <Text color="gray6" fontSize="12px" fontWeight="300" pb={3}>
            {' '}
            Secure checkout with Stripe 💳
          </Text>
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        <Flex flexWrap="wrap" direction="column" align="center" pb="150px">
          <Box align="center" mx="auto" width={1} align="center">
            <CheckoutSelect updatePlan={this.updatePlan} />
          </Box>
          <Box mx="auto">{this.renderButton()}</Box>

          {this.state.paymentMessage}
        </Flex>
      </div>
    );
  }
};

export default Checkout;
